import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, DefaultButton, Dropdown, Modal, PrimaryButton, TextField } from '@fluentui/react';
import * as Api from '../../../../api/src';
import ModalHeader from '../../../../control/modalHeader';
import { ToastAppMsgContext } from '../../../../context/toastApp.Context';
import { ToastAppType } from '../../../../common/constant/enum/toastAppType';
export interface ModaCategoryProps {
  IsOpen: boolean;
  ProductType: number;
  onCloseModal: () => void;
  onSaveClick?: () => void;
  Item?: Api.Category | null;
}
const ProductTypesApi = new Api.ProductTypesApi();
const CategoriesApi = new Api.CategoriesApi();
const ModalCategory = ({ onSaveClick, Item, IsOpen, onCloseModal, ProductType }: ModaCategoryProps) => {
  const [isShow, SetIsShow] = React.useState(false);
  const [detail, SetDetail] = React.useState<Api.Category>({});
  const [nameErrorMessage, SetNameErrorMessage] = React.useState('');
  const [productTypeErrorMessage, SetProductTypeErrorMessage] = React.useState('');
  const [listProductType, setListProductType] = React.useState<any[]>([]);
  const { setToastData } = React.useContext(ToastAppMsgContext);
  const { t } = useTranslation();
  const getTitle = (): string => {
    if (Item) {
      return t('EditCategory');
    }
    return t('NewCategory');
  };
  React.useEffect(() => {
    SetIsShow(IsOpen);
    if (IsOpen) {
      getAllProductTypes().then(() => {
        if (Item != null) {
          getItemData();
        }
      });
    } else {
      SetDetail({ States: Api.StatesEnum.Active });
    }
    SetNameErrorMessage('');
    SetProductTypeErrorMessage('');
  }, [IsOpen]);
  const onClose = () => {
    onCloseModal();
    SetIsShow(false);
  };
  const getItemData = async () => {
    var data = (await CategoriesApi.apiCategoriesIdGet(Item?.Id || 0)).data;
    SetDetail(data.Data || { States: Api.StatesEnum.Active });
    SetIsShow(IsOpen);
  };
  const validateFormData = () => {
    let pass = true;
    if (!detail.Name) {
      SetNameErrorMessage(t('NameIsRequired'));
      pass = false;
    }
    if (!detail.ProductTypeId) {
      SetProductTypeErrorMessage(t('IsRequired').replace('{0}', t('ProductType')));
      pass = false;
    }
    return pass;
  };
  const onSave = async () => {
    if (!validateFormData()) {
      return;
    }
    var data = await CategoriesApi.apiCategoriesPost({ Model: detail });
    if (!data || data.status != 200) return;
    setToastData({ Message: t('Successed'), Type: ToastAppType.Success });
    onCloseModal();
    SetIsShow(false);
    if (onSaveClick) {
      onSaveClick();
    }
  };
  const getAllProductTypes = async () => {
    let productTypes: any[] = listProductType || [];
    if (productTypes.length === 0) {
      let data = (
        await ProductTypesApi.apiProductTypesPagedPost({
          PageNumber: 1,
          OrderBy: [{ ColumnName: 'Name' }],
          PageSize: 0,
          SearchString: '',
          GetOnlyActive: true,
        })
      ).data;
      data.Data?.forEach((element) => {
        productTypes.push({ key: element.Id, text: element.Name });
      });
      setListProductType(productTypes);
    }
    if (productTypes.length > 0 && Item == null) {
      SetDetail({
        ...detail,
        ProductTypeId: ProductType ? ProductType : productTypes[0].key,
        States: Api.StatesEnum.Active,
      });
    }
  };
  return (
    <Modal isOpen={isShow} isModeless={true}>
      <ModalHeader
        title={getTitle()}
        onCloseModal={() => {
          onClose();
        }}
      />
      <div className={'modal-content'} style={{ width: 700 }}>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-md12  ms-Grid-col padding-left-0 padding-right-0">
              <TextField
                autoFocus={true}
                errorMessage={nameErrorMessage}
                label={t('Name') + ' (*)'}
                value={detail?.Name || ''}
                onChange={(e, newValue) => {
                  SetDetail({ ...detail, Name: newValue });
                  SetNameErrorMessage('');
                }}
              ></TextField>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-md12  ms-Grid-col padding-left-0 padding-right-0">
              <Dropdown
                label={t('ProductType') + ' (*)'}
                options={listProductType}
                errorMessage={productTypeErrorMessage}
                placeholder={t('SelectAProductType')}
                selectedKey={detail.ProductTypeId}
                onChange={(e, option) => {
                  SetDetail({ ...detail, ProductTypeId: option?.key as number });
                  SetProductTypeErrorMessage('');
                }}
              ></Dropdown>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-md6 margin-0 padding-left-0 ms-Grid-col">
              <Checkbox
                label={t('Active')}
                checked={detail?.States === Api.StatesEnum.Active ? true : false}
                onChange={(e, checked) => {
                  SetDetail({ ...detail, States: checked ? Api.StatesEnum.Active : Api.StatesEnum.Inactive });
                }}
              ></Checkbox>
            </div>
          </div>
        </div>
      </div>
      <div className={'modal-footer'}>
        <DefaultButton
          onClick={() => {
            onClose();
          }}
          className={'margin-left-10'}
        >
          {t('Close')}
        </DefaultButton>
        <PrimaryButton
          className={'margin-left-10'}
          onClick={() => {
            onSave();
          }}
        >
          {t('Save')}
        </PrimaryButton>
      </div>
    </Modal>
  );
};
export default ModalCategory;
